import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network/ngx';
import { BehaviorSubject } from 'rxjs';
import swal from 'sweetalert'
@Injectable({
  providedIn: 'root'
})
export class WifiService {

  private onlineStatus: BehaviorSubject<boolean>;

  constructor(private network: Network) {
    this.onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);
    this.network.onConnect().subscribe(() => this.updateOnlineStatus(true));
    this.network.onDisconnect().subscribe(() => this.updateOnlineStatus(false));
  }

  private updateOnlineStatus(isOnline: boolean) {
    this.onlineStatus.next(isOnline);
  }
  async netWorkState(){
    console.log(this.network.onChange())
  }
  isOnline() {
    return this.onlineStatus.asObservable();
  }
  async wifiState(){
   this.network.onChange().subscribe(f=>{
    console.log(f)
   })
    //http://localhost:8100/seed-point?service=%7B%22id%22:%220axizvco0t1f%22%7D
   
  }

  
}
